import { Box, IconButton } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from "@mui/lab";

type BaseTimelineItemConfig = {
	accentColor: string;
	icon: React.ReactNode;
	isSelected: boolean;
	dotVariant?: "nested";
	linkUrl?: string;
};

type BaseTimelineItemProps = {
	config: BaseTimelineItemConfig;
	children: React.ReactNode;
};

export const BaseTimelineItem = ({ config, children }: BaseTimelineItemProps) => {
	const { accentColor, icon, isSelected, dotVariant, linkUrl } = config;

	return (
		<TimelineItem>
			<TimelineSeparator>
				{dotVariant === "nested" ? (
					<TimelineDot
						variant="outlined"
						sx={{ width: 12, height: 12, borderColor: accentColor, boxShadow: "none" }}
					/>
				) : (
					<TimelineDot sx={{
						width: 24,
						height: 24,
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						p: 0,
						backgroundColor: `${accentColor}18`,
						border: `2px solid ${accentColor}`,
						boxShadow: "none",
					}}>
						{icon}
					</TimelineDot>
				)}
				<TimelineConnector sx={{ backgroundColor: "grey.200", width: "2px" }} />
			</TimelineSeparator>
			<TimelineContent>
				<Box
					sx={{
						p: 1.5,
						borderRadius: 2,
						borderLeft: `3px solid ${accentColor}`,
						backgroundColor: isSelected ? `${accentColor}0F` : "background.paper",
						boxShadow: isSelected
							? `0 0 0 1px ${accentColor}33`
							: "0 1px 3px rgba(0,0,0,0.04)",
						transition: "all 0.15s ease",
						"&:hover": {
							backgroundColor: `${accentColor}08`,
							boxShadow: `0 0 0 1px ${accentColor}20`,
						},
						display: "flex",
						alignItems: "center",
					}}
				>
					{children}
				{linkUrl && (
					<IconButton component={Link} to={linkUrl} target="_blank" size="medium" color="secondary" sx={{ ml: 1 }}>
						<OpenInNew sx={{ fontSize: 22 }} />
					</IconButton>
				)}
				</Box>
			</TimelineContent>
		</TimelineItem>
	);
};
